export default "__VITE_ASSET__hUaf6HfY__"